import React from "react";
import MedicineAutocomplete from "../services/medicineAutocomplete"; // Adjust the import path as necessary

const Medication = ({
  medication,
  onFieldChange,
  index,
  medicationTypes,
  medicationFrequencies,
  medicationInstructions,
  removeMedication,
}) => {
  const handleSuggestionSelected = (selectedOption) => {
    if (!selectedOption) {
      // Handle the case where there is no selection
      // For example, reset the medication_id and medicine fields
      onFieldChange(index, { target: { name: "medicine", value: "" } });
      onFieldChange(index, { target: { name: "medication_id", value: "" } });
      onFieldChange(index, {
        target: { name: "dosage", value: '' },
      });
      onFieldChange(index, {
        target: { name: "type", value: ''},
      });
    } else {
      onFieldChange(index, {
        target: { name: "medicine", value: selectedOption.label },
      });
      onFieldChange(index, {
        target: { name: "medication_id", value: selectedOption.value },
      });
      onFieldChange(index, {
        target: { name: "dosage", value: selectedOption?.other?.dosage||'' },
      });
      onFieldChange(index, {
        target: { name: "type", value: (selectedOption?.other?.type?.toUpperCase() ||'' )},
      });
    }
  };

  return (
    <div key={index} className="mb-4">
      {/* Medication Name */}
      <div className="grid grid-cols-1 mb-4">
        <MedicineAutocomplete
          name="medicine"
          value={{
            label: medication.medicine,
            value: medication.medication_id,
          }}
          onChange={(e) => onFieldChange(index, e)} // we need to adjust this part
          placeholder="Enter medicine name"
          onSuggestionSelected={handleSuggestionSelected}
          className="p-2 border border-gray-300 rounded-md col-span-1 dropdown-control"
        />
      </div>

      <div className=" flex flex-wrap  mb-4 -mx-2 gap-y-4">
        {/* Dosage Field */}
        <div className=" w-4/12 px-2">
          <input
            type="text"
            name={`dosage`}
            value={medication.dosage}
            onChange={(e) => onFieldChange(index, e)}
            placeholder="Enter dosage (e.g., 500mg)"
            className="input-control  w-full"
          />
        </div>

        {/* Frequency Dropdown */}
        <div className=" w-4/12 px-2">
          <select
            name={`frequency`}
            value={medication.frequency}
            onChange={(e) => onFieldChange(index, e)}
            className="select-control w-full"
          >
            <option value="">Frequency</option>
            {medicationFrequencies.map((frequency, frequencyIndex) => (
              <option key={frequencyIndex} value={frequency}>
                {frequency}
              </option>
            ))}
          </select>
        </div>

        {/* Type Dropdown */}
        <div className=" w-4/12 px-2">
          <select
            name={`type`}
            value={medication.type}
            onChange={(e) => onFieldChange(index, e)}
            className="select-control w-full"
          >
            <option value="">Type</option>
            {medicationTypes.map((type, typeIndex) => (
              <option key={typeIndex} value={type.toUpperCase()}>
                {type.toUpperCase()}
              </option>
            ))}
          </select>
        </div>

        {/* Duration Field */}
        <div className=" w-4/12 px-2">
          <input
            type="number"
            name={`duration`}
            value={medication.duration}
            onChange={(e) => {
              if (e.target.value < 1) {
                e.target.value = 1;
              }
              onFieldChange(index, e);
            }}
            placeholder="Duration (days)"
            className="input-control w-full"
          />
        </div>

        {/* Instruction Dropdown */}
        <div className=" w-4/12 px-2">
          <select
            name={`instructions`}
            value={medication.instructions}
            onChange={(e) => onFieldChange(index, e)}
            className="select-control w-full"
          >
            <option value="">Instructions</option>
            {medicationInstructions.map((instruction, instructionIndex) => (
              <option key={instructionIndex} value={instruction}>
                {instruction}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-7">
        {/* Remove Button */}
        <div className="col-span-1 md:col-span-2 lg:col-span-4 flex justify-end">
          <button
            type="button"
            onClick={() => removeMedication(index)}
            className="text-red-700 bg-red-100 hover:bg-red-200 focus:ring-4 focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:focus:ring-red-900 transition-colors"
          >
            Remove
          </button>
        </div>
      </div>
    </div>
  );
};

export default Medication;
